<template>
    <div class="page container">
        <h1 class="is-size-3"><small class="has-text-weight-bold">Meus Cursos</small> </h1>
        <br />
			<hr />
			<el-table
		    :data="cursos"
		    stripe
		    style="width: 100%" v-if='cursos.length > 0'>
		    <el-table-column
		      prop="titulo"
		      label="Título">
		      <template slot-scope="scope">
		        <span style="margin-left: 10px"><b>{{scope.row.titulo }}</b></span>
		      </template>
		    </el-table-column>
		    <el-table-column
		      prop="inscritos"
		      label=""
		      width="150"
		      >
		      <template slot-scope="scope">
		        <span style="margin-left: 10px"></span>
		      </template>
		    </el-table-column>
		    <el-table-column
		      label=""
		      width="160">
		      <template slot-scope="scope">
	          <el-button-group>
		        	<el-button type="primary" size="small" @click='openCurso(scope.row)'><i class="fas fa-sign-in-alt" ></i></el-button>
		        </el-button-group>
		      </template>
		    </el-table-column>
		  </el-table>
      <div v-else>
        <p>Você ainda não se inscreveu em nehum curso.</p>
        <p>Visite a nossa página de <el-button type="text" @click="() => $router.push('/p/cursos')">Cursos</el-button></p>

      </div>
    </div>
</template>


<script>
import moment from 'moment'
import utils from '@/utils'
import { mapState } from 'vuex'
import Store from '@/store'
import axios from 'axios'


export default {
		watch: {
	    '$route.params': function (params) {
	      this.load(params);
	    }
	  },
	  computed:{
		  ...mapState({
	      disciplinas: state => state.session.disciplinas
	      
	    }),
		},
	  data(){
	  	return {
	  		activeIndex2: '1',
	  		tituloCurso: '',
        cursos: [
        ]
      }
	  },
		methods:{
			openCurso(row){
				this.$router.push(`/usuario/curso/${row.id}/visualizar`)
			},
		
			formatConteudo(conteudos){
				
				const maped = conteudos.map(c=>c.descricao);
				const joined = maped.join(",")
				if(joined == "")
					return "SEM DESCRIÇÃO"
				else
					return joined	
				
			},
			formatAtualizacao(atualizacao){
				return moment(atualizacao).fromNow();
			},
			formatData(data){
				if(data)
					return moment(data).format('DD | MMM')
				else
					return " - "
			},
			
      getCursos(){
      	global.Loading.begin('Carregando cursos');
      	axios.get(`${global.base}/api/usuario/cursos`,{
          headers: { 'authorization': `bearer ${this.$store.state.session.jwt}` },
          }).then((r)=>{
          	
            this.cursos = r.data.map((c) => {
            	return {...c, visivel: c.visivel == 1 ? true : false}
            });
            setTimeout(global.Loading.end, 2500 )
              
          }).catch(()=>{
            global.Loading.end();
          })
      },

		},
    mounted(){
			const params = this.$router.currentRoute.params;
			this.getCursos();
    }
};
</script>

<style scoped>

</style>
